import { FC } from "react";
import styled from "styled-components";

const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: var(--x-gray-200);
`;

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--x-gray-300);
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: var(--x-cyan);
  }
`;

/* eslint-disable react/require-default-props */
interface DashboardHeaderProps {
  title: string;
  actionText?: string;
  onActionClick?: () => void;
}
/* eslint-enable react/require-default-props */

const DashboardHeader: FC<DashboardHeaderProps> = ({
  title,
  actionText = "",
  onActionClick,
}) => (
  <PanelHeader>
    <Title>{title}</Title>
    <div className="d-flex align-items-center gap-3">
      {actionText && (
        <ActionGroup onClick={onActionClick}>{actionText}</ActionGroup>
      )}
    </div>
  </PanelHeader>
);

export default DashboardHeader;
